import {
	GET_CASE_AMOUNT_BUCKET,
	GET_CASE_AMOUNT_BUCKET_SUCCESS,
	GET_CASE_AMOUNT_BUCKET_FAIL,
	GET_CASE_AMOUNT_BUCKET_RESET,
} from '../actions/getCaseAmountBucketAction';

const initialState = {
	apiState: '',
	message: '',
	data: null,
	error: '',
};

const getCaseAmountBucketReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_CASE_AMOUNT_BUCKET:
			return {
				...state,
				apiState: 'loading',
			};
		case GET_CASE_AMOUNT_BUCKET_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.response.data,
				message: action.response.message
					? action.response.message
					: 'success',
			};
		case GET_CASE_AMOUNT_BUCKET_FAIL:
			return {
				...state,
				apiState: 'error',
				error: action.response.errors,
				message: action.response.message
					? action.response.message
					: 'error',
			};
		case GET_CASE_AMOUNT_BUCKET_RESET:
			return initialState;
		default:
			return state;
	}
};

export default getCaseAmountBucketReducer;
